<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_LABEL_RELEASES_ACTION_OPTION_DELIVER_RELEASE"
        maxDialogWidth="1200"
        maxCardHeight="1200"
        :close="close"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <!-- <v-container 
                v-for="(release, i) in releaseDeliveryDialogDetails"
                :key="i"
                fluid
            > -->
            <v-container fluid>
                <v-row>
                    <v-col cols="2">
                        <v-img 
                            v-if="releaseDetails.cover !== undefined && releaseDetails.cover !== null"
                            :src="releaseDetails.cover"
                            width="130px"
                            :alvqa="alvqa + '-cover'"
                        ></v-img>
                        <v-img 
                            v-else
                            :src="require('@/assets/default_picture/default.jpg')"
                             width="120px"
                            :alvqa="alvqa + '-cover'"
                        ></v-img>
                    </v-col>
                    <v-col cols="6">
                        <v-row>
                            <v-col>
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-name'"
                                >{{ $t('lang_LABEL_RELEASES_CAPTION_TITLE') }}</div>
                                <div :alvqa="alvqa + '-name'">
                                    {{ releaseDetails.name }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-' + releaseDetails.alvId + '-caption-performer'"
                                >{{ $t('lang_LABEL_RELEASE_CAPTION_DISPLAY_ARTIST') }}</div>
                                <div :alvqa="alvqa + '-performer'">
                                    {{ $alvPlugin.getArtistOrPerformerName(releaseDetails.displayArtist) }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-' + releaseDetails.alvId + '-caption-other-contributors'"
                                >{{ $t('lang_LABEL_RELEASE_CAPTION_OTHER_CONTRIBUTORS') }}
                                </div>
                                <div :alvqa="alvqa + '-other-contributors'">
                                    {{ getOtherContributors(releaseDetails.artists) }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col>
                        <v-row v-if="releaseDetails.ean !== '' && releaseDetails.ean !== null">
                            <v-col>
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-' + releaseDetails.alvId + '-caption-ean-upc'"
                                >{{ $t('lang_LABEL_RELEASES_CAPTION_EAN_UPC') }}</div>
                                <div :alvqa="alvqa + '-ean-upc'">
                                    {{ releaseDetails.ean }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="releaseDetails.dateDigital !== '' && releaseDetails.dateDigital !== null">
                            <v-col>
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-' + releaseDetails.alvId + '-caption-digital-release-date'"
                                >{{ $t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL') }}</div>
                                <div :alvqa="alvqa + '-digital-release-date'">
                                    {{ getFormattedDate(releaseDetails.dateDigital) }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col>
                        <v-row>
                            <!-- Validation in progress -->
                            <!-- <v-col v-if="releaseValidationInProgress">
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-xml-file'"
                                >
                                    Validation
                                </div>
                                <div :alvqa="alvqa + '-in-progress'">
                                    In progress...
                                </div>
                            </v-col> -->

                            <!-- Validation is done and without errors -->
                            <!-- <v-col  v-if="!releaseValidationInProgress && xmlPath !== null">
                                <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-xml-file'"
                                >
                                    {{ $t('lang_GENERAL_CAPTION_XML') }} {{ $t('lang_PUBLISHING_TRACKING_SETLISTS_PANEL_CAPTION_FILE') }}
                                </div>
                                <div :alvqa="alvqa + '-xml-file'">
                                    <a :href="xmlPath" target="_blank">{{ $t('lang_MODULES_CLICK_HERE') }}</a>
                                </div>
                            </v-col> -->

                            <!-- Validation is done but with errors -->
                            <v-col v-if="!releaseValidationInProgress && xmlValidationErrorPath !== null">
                                <div
                                    class="read-only-caption error--text"
                                    :alvqa="alvqa + '-caption-xml-file'"
                                >
                                    {{ $t('lang_GENERIC_MESSAGE_ERROR_XML_VALIDATION_FAILED') }}
                                </div>
                                <div :alvqa="alvqa + '-xml-file'">
                                    <a :href="xmlValidationErrorPath" target="_blank">{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}</a>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col> 
                </v-row>
            
                <v-row>
                    <!-- TRACKS -->
                    <v-col cols="9">
                        <v-data-table
                            :headers="trackHeaders"
                            :items="tracks"
                            hide-default-footer
                            class="noMinWidth"
                            :header-props="{ sortIcon: '' }"
                            :items-per-page="itemsPerPage"
                            :page.sync="currentPage"
                        >
                            <!-- Alvqas for headers -->
                            <template v-for="(header, i) in trackHeaders" v-slot:[`header.${header.value}`]>
                                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                            </template>
                        
                            <!-- Items -->
                            <template v-slot:[`item.title`]="{ item }">
                                <div class="ellipsis">
                                    <BaseTooltip 
                                        :simpleText="getTitle(item)"
                                        :alvqa="alvqa +'-list-row-' + item.id + '-text-track-title'"
                                    />
                                </div>
                            </template>
                            <template v-slot:[`item.isrc`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.alvId + '-text-isrc'">
                                    {{ item.isrc }}
                                </div>
                            </template>
                            <template v-slot:[`item.performer`]="{ item }">
                                <div class="ellipsis">
                                    <BaseTooltip 
                                        :simpleText="$alvPlugin.getArtistOrPerformerName(item.displayArtist)"
                                        :alvqa="alvqa +'-list-row-' + item.id + '-text-display-artist'"
                                    />
                                </div>
                            </template>
                            <template v-slot:[`item.duration`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.alvId + '-text-duration'">
                                    {{ $alvPlugin.transformSecondsToDuration(item.duration) }}
                                </div>
                            </template>
                        </v-data-table>
                        <div>
                            <v-pagination   
                                v-if="pages() > 1"
                                total-visible="10" 
                                v-model="currentPage" 
                                :length="pages()"
                                color="pagination"
                            ></v-pagination>
                        </div>
                    </v-col>
                    <!-- PLATFORMS -->
                    <v-col>
                        <v-data-table
                            :headers="platformHeaders"
                            :items="getPlatformItems(releaseDetails.digitalDistributionStatus)"
                            hide-default-footer
                            class="noMinWidth"
                            :header-props="{ sortIcon: '' }"
                        >

                            <!-- Alvqas for headers -->
                            <template v-for="(header, i) in platformHeaders" v-slot:[`header.${header.value}`]>
                                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                            </template>

                            <template v-slot:[`item.platform`]="{ item }">
                                <v-img 
                                    :src="require('@/assets/logo/digital_distribution/' + item.platformId.toLowerCase() + '-22px.png')" 
                                    contain height="18px" 
                                    position="left"
                                    :alvqa="alvqa + '-' + item.alvId + '-platform'"
                                />
                            </template>
                            <!-- <template v-slot:[`item.digitalPreRelease`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.alvId + '-text-prerelease'">
                                    {{ getFormattedDate(item.digitalPreRelease) }}
                                </div>
                            </template> -->
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid >
                <!-- VALIDATION row -->
                    <v-row v-if="releaseValidationInProgress">
                        <v-spacer />
                        <v-col 
                            cols="3"
                            class="text-right mt-2"
                        >
                            {{ $t('lang_LABEL_RELEASES_DELIVER_RELEASE_DIALOG_VALIDATION_METADATA') }}
                        </v-col>
                        <v-col
                            cols="2"
                            align-self="center"
                        >
                            <v-progress-linear
                                color="dialogProgressbar"
                                indeterminate
                                :alvqa="alvqa + '-process-progressbar-validation'"
                            />
                        </v-col>
                    </v-row>

                <!-- FINISHED VALIDATION , clickable DELIVER BUTTON -->
                    <v-row v-if="!releaseValidationInProgress && showDeliverReleaseButton && !showMainProgressbar"  align="center">
                        <v-spacer />
                        <v-col 
                            cols="6"
                            class="text-right pr-0"
                        >
                            <span v-if="xmlValidationErrorPath == null">
                                {{ $t('lang_GENERAL_CAPTION_DOWNLOAD_FILE') }}
                            </span>
                            <span>
                                <BaseIcon
                                    @click.stop="downloadFile(xmlPath)" 
                                    icon="cloud_download" 
                                    :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                                    :alvqa="alvqa + '-icon-download-file-distribution'"
                                    style="vertical-align: middle;"
                                    v-if="xmlValidationErrorPath == null"
                                />
                            </span>
                            <span class="px-1" v-if="xmlValidationErrorPath == null">|</span>
                            {{ $t('lang_LABEL_RELEASES_DELIVER_RELEASE_DIALOG_FOR_DELIVERY_CLICK_HERE') }}
                            <!-- <a :href="xmlValidationErrorPath !== null ? xmlValidationErrorPath : xmlPath" target="_blank">.</a> -->
                        </v-col>
                        <v-col 
                            cols="2"
                            class="text-right pl-0"
                        >
                            <BaseButton
                                :disabled="xmlPath === null"
                                icon="cloud_upload"
                                label="lang_LABEL_RELEASES_BUTTON_CAPTION_DELIVER"
                                @click="deliverRelease()"
                                :alvqa="alvqa+'-button-upload'"
                            />
                        </v-col>
                    </v-row>
                
                <!-- MAIN PROGRESSBAR for SENDING -->
                    <v-row v-if="showMainProgressbar">
                        <v-spacer />
                        <v-col 
                            cols="5"
                            align-self="center"
                        >
                            <v-progress-linear
                                v-model="mainProcessValue"
                                color="dialogProgressbar"
                                :alvqa="alvqa + '-process-progressbar'"
                            />
                        </v-col>
                    </v-row>
                <!-- DELIVERY SUCCESSFULL -->
                    <v-row v-if="showDeliverySuccessfullMessage">
                        <v-spacer />
                        <v-col
                            cols="5"
                            class="text-right mt-2"
                        >
                            {{ $t('lang_LABEL_RELEASES_DELIVER_RELEASE_DIALOG_DELIVERY_SUCCESSFULL') }}
                        </v-col>
                    </v-row>
                </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import api from '@/api_alv.js'

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseIcon from '@/components/_buttons/BaseIcon'


import { DropdownGeneralArtistRoles } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "LabelReleasesDeliveryDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseTooltip,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'label-releases-list-dialog-deliver-release',
            showProcessProgressbar: true,
            polling: null,
            mainProcessValue: 0,
            showDeliverReleaseButton: true,
            showMainProgressbar: false,
            showDeliverySuccessfullMessage: false,
            currentPage: 1,
            itemsPerPage: 100
        }
    },
    computed: {
        tracks() {
            let tracks = []
            for(let discNr in this.releaseDetails.tracksOnRelease) {
                this.releaseDetails.tracksOnRelease[discNr].forEach(track => {
                    tracks.push(track)
                })
            }

            return tracks
        },
        showDialog: {
            get() { return this.$store.getters.getShowReleaseDeliveryDialog },
            set(show) { this.$store.commit('setShowReleaseDeliveryDialog', show) }
        },
        xmlPath: { 
            get() { return this.$store.getters.getXmlFilePath },
            set(path) { this.$store.commit('setXmlFilePath', path) }
        },
        xmlValidationErrorPath: { 
            get() { return this.$store.getters.getXmlValidationErrorPath },
            set(path) { this.$store.commit('setXmlValidationErrorPath', path) }
        },
        releaseValidationInProgress: { 
            get() { return this.$store.getters.getReleaseValidationInProgress },
            set(inProgress) { this.$store.commit('setReleaseValidationInProgress', inProgress) }
        },
        // showCloseButton: { 
        //     get() { return this.$store.getters.getShowCloseButton },
        //     set(show) { this.$store.commit('setShowCloseButton', show) }
        
        // },
        // showMainProgressbar: {
        //     get() { return this.$store.getters.getShowMainProgressbar },
        //     set(show) { this.$store.commit('setShowMainProgressbar', show) }
        // },

        releaseDetails() { return this.$store.getters.getReleaseDeliveryDialogDetails },
        // mainProcessValue() { return this.$store.getters.getMainPercentageProgressbarReleaseDelivery },
        selectedReleasesDetails() {
            let selectedReleases = this.$store.getters.getSelectedLabelReleases
            let detailsArray = []

            selectedReleases.forEach(releaseAlvId => {
                let releaseDetails = this.$store.getters.getLabelReleases.find(release => {
                    return release.alvId === releaseAlvId
                })

                detailsArray.push(releaseDetails)
            });

            return detailsArray
        },

        trackHeaders() {
            return [
                {
                    text: this.$t('lang_LABEL_TRACKS'), 
                    value: 'title',
                    align: 'left',
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-tracks'
                },
                {
                    text: this.$t('lang_LABEL_TRACKS_CAPTION_ISRC'), 
                    value: 'isrc',
                    align: 'left',
                    sortable: false,
                    class: 'text-no-wrap',
                    width: "160px",
                    alvqa: this.alvqa + '-header-isrc'
                },
                {
                    text: this.$t('lang_LABEL_TRACKS_CAPTION_DISPLAY_ARTIST'), 
                    value: 'performer',
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-display-artist'
                },
                {
                    text: this.$t('lang_LABEL_TRACKS_CAPTION_DURATION'), 
                    value: 'duration',
                    align: 'right', 
                    sortable: false,
                    width: '90px',
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-duration'
                },
            ]
        },

        platformHeaders() {
            return [
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_PLATFORM'), 
                    value: 'platform',
                    align: 'left',
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-platform'
                },
                // {
                //     text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_PRERELEASE'), 
                //     align: "left", 
                //     value: "digitalPreRelease",
                //     class: 'text-no-wrap',
                //     alvqa: this.alvqa + '-header-prerelease-date'
                // },
            ]
        }
    },
    methods: {
        pages() {
            if (this.tracks.length === 0) return 0 
            return Math.ceil(this.tracks.length / this.itemsPerPage)
        },
        close() {
            this.showDialog = false
            this.xmlPath = null,
            this.xmlValidationErrorPath = null
            this.releaseValidationInProgress = true
            this.showDeliverReleaseButton = true
            this.showMainProgressbar = false
            this.showDeliverySuccessfullMessage = false
            this.$store.commit('setReleaseDeliveryDialogDetails', {})
            // this.$store.commit('setReleaseDeliveryDialogDetails', [])
            this.$store.commit('setSelectedLabelReleases', [])
            this.$store.commit('setIsAllSelectedLabelReleases', false)
            this.$store.commit('setSelectedLabelReleasesAction', [])
            this.$store.commit('setMainPercentageProgressbarReleaseDelivery', 0)
        },
        async deliverRelease() {
            // this.$store.dispatch('deliverLabelRelease')
            this.showMainProgressbar = true

            let queryParams = { "action": "deliverRelease" }
            let metaData = { "releaseIds" : this.$store.getters.getSelectedLabelReleases }

            // API Call to trigger function
            let actionResponse = await api.triggerAction("label/releases", metaData, queryParams)

            if(actionResponse.error === -1) {
                // let processReleaseResponse = await dispatch('processDeliverLabelRelease', { processId: response.response.processId })
                let processDeliverReleaseResponse = await this.processDeliverRelease(actionResponse)

                if(processDeliverReleaseResponse.status === 'running') {
                        this.polling = setInterval(() => {
                        this.processDeliverRelease(actionResponse) 
                    }, 3000)
                    setTimeout(() => { clearInterval(this.polling) }, 1800000)
                }
            }
        },
        async processDeliverRelease(actionResponse) {
            let result = await api.getProgressOfProcess(actionResponse.response.processId, this.polling).then(response => { return response })
            this.mainProcessValue = result.percent
            
            if(result.status === 'finished') { 
                if (result.error == -1) {
                    this.showDeliverReleaseButton = false
                    this.showMainProgressbar = false
                    this.showDeliverySuccessfullMessage = true
                    clearInterval(this.polling)
                } else {
                    this.showDeliverReleaseButton = false
                    this.showMainProgressbar = false
                    let message = this.$t(result.errorMsg)
                    this.$store.commit('setSnackbar', { 
                        type: 'error', 
                        msg: message
                    })
                }
            }

            return result
        },
        
        getFormattedDate(date) {  
            if(date === null || date === undefined || date === '') return ''
            else return this.$d(new Date(date), 'alvDateFormat') 
        },

        getPlatformItems(allDigitalDistributionStatusItems) {
            if(allDigitalDistributionStatusItems === null || allDigitalDistributionStatusItems === undefined) return [] 
            else {
                let copyOfAll = JSON.parse(JSON.stringify(allDigitalDistributionStatusItems))
                let items = []

                copyOfAll.forEach(item => {
                    if(item.selected === 'yes') {
                        items.push(item)
                    }
                })
                return items
            }
        },
        getTitle(item) {
            let titleCol = item.title
            if( item.version !== null) titleCol += ' (' + item.version + ')'
            return titleCol
        },
        getOtherContributors(artists) {
            let otherContributorsString = []
            if(artists === null || artists === undefined) return ''
            else {
                artists.forEach(element => {
                    otherContributorsString.push(element.artist.name + ' (' + this.getRole(element.role) + ')')
                })
            }
            return otherContributorsString.join(', ')
        },
        getRole(roleValue) {
            let roles = DropdownGeneralArtistRoles

            if(roles !== undefined) {
                return roles.find(role => {
                    return role.value === roleValue
                }).text
            }
        },

        downloadFile(download_path) {
            if (download_path === null) {
                return;
            }

            api.getFileFromALV(download_path)
            this.$store.commit('setSnackbar', {
                type: 'success',
                msg: this.$t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>